import React, { useEffect, useState } from "react";
import api from "@/lib/api";

// Platform-wide seasonal tint — a faint top wash in the live event's accent so the whole
// site subtly feels in-season. Pointer-events-none and low-alpha, so it never gets in the way.
export default function SeasonalTint() {
  const [accent, setAccent] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/events/active")
      .then((r) => { if (alive && r.data?.active && r.data?.accent) setAccent(r.data.accent); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (accent && typeof document !== "undefined") {
      document.documentElement.style.setProperty("--event-accent", accent);
    }
  }, [accent]);

  if (!accent) return null;
  return (
    <div
      aria-hidden
      data-testid="seasonal-tint"
      className="pointer-events-none fixed inset-x-0 top-0 h-56 z-40"
      style={{ background: `radial-gradient(70% 100% at 50% 0%, ${accent}2e, transparent 72%)` }}
    />
  );
}
